import { Route, Routes, useParams, useResolvedPath } from 'react-router-dom';
import GridTicketsData from '../../../features/tickets/components/GridTicketsData';
import Error404 from '../../../components/error/Error404';
import TicketsOperationProvider from '../../../features/tickets/context/TicketsOperationContext';
import DetailTicket from '../../../features/tickets/components/DetailTicket';

export default function TicketsOperations() {
    const path = useResolvedPath("").pathname;
    const { id } = useParams();

    return (
        <TicketsOperationProvider path={path} dashboardId={id}>
            <Routes>
                <Route path="/" element={<GridTicketsData />} />
                <Route path="/detalle/:idTicket" element={<DetailTicket />} />
                <Route path='*' element={<Error404 />} />
            </Routes>
        </TicketsOperationProvider>
    )
}
